// extracted by mini-css-extract-plugin
export default {"loading-wrapper":"tag-performance-dashboard_loading-wrapper__dvmTg"};